/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { SdsDivProps } from '../Component.props';

/**
 * The props for `<Accordion />`.
 */
export interface AccordionProps extends SdsDivProps {
  /**
   * Content for the accordion body.
   */
  body?: React.ReactNode;

  /**
   * Content for the accordion header.
   */
  header: React.ReactNode;

  /**
   * Label text for hiding the content.
   */
  toggleTextHide?: string;

  /**
   * Label text for showing the content.
   */
  toggleTextShow?: string;

  /**
   * Controls whether the accordion is open by default.
   */
  defaultOpen?: boolean;
}

/**
 * The default prop values for `<Accordion />`.
 */
export const accordionDefaults = {
  body: null,
  toggleTextHide: `Hide details`,
  toggleTextShow: `Show details`,
};
